import React from 'react';
import {
    arrayOf,
    element,
    func,
    node,
    oneOfType,
    string
} from 'prop-types';

import Paper from '@material-ui/core/Paper';

import EsmsBreadcrumb from './EsmsBreadcrumb';

import classes from './EsmsPage.module.css';

const EsmsPage = ({
    child,
    children,
    handlers,
    header,
    headerControl,
    iconSrc,
    parents,
    sidebar,
    subtitle,
    title
}) => {
    child || (child = title);

    let sidebarContent = null;
    if (sidebar) {
        sidebarContent = (
            <aside className={classes.sidebar}>
                {sidebar}
            </aside>
        );
    }

    let subtitleContent = null;
    if (subtitle) {
        subtitleContent = (
            <aside className={classes.subtitle}>
                {subtitle}
            </aside>
        );
    }

    let icon = null;
    if (iconSrc) {
        icon = <img alt="" className={classes.icon} src={iconSrc} />;
    }

    let headerControlContent = null;
    if (headerControl) {
        headerControlContent = (
            <div className={classes.headerControl}>
                {headerControl()}
            </div>
        );
    }

    return (
        <main className={classes.root}>
            {headerControlContent}
            <header className={classes.pageHeader}>
                {header}
                <EsmsBreadcrumb
                    className={classes.nav}
                    parents={parents}
                    child={child}
                    handlers={handlers}
                />
            </header>
            <Paper className={classes.body}>
                <header className={classes.bodyHeader}>
                    {icon}
                    {title}
                    {subtitleContent}
                </header>
                {children}
            </Paper>
            {sidebarContent}
        </main>
    );
};

EsmsPage.defaultProps = {
    handlers:      [],
    headerControl: () => {},
    parents:       []
};

EsmsPage.propTypes = {
    children:      node,
    handlers:      arrayOf(func),
    headerControl: func,
    iconSrc:       string,
    parents:       arrayOf(string),
    sidebar:       node,
    subtitle:      oneOfType([string, element]),
    title:         string.isRequired
};

export default EsmsPage;
